export default __webpack_public_path__ + "static/media/gotham-book.9c2a0ce4.woff2";